/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFusionAnalyticWarehouse = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20.474.393a.482.482 0 0 0-.948 0l-.46 2.065a.49.49 0 0 1-.515.39l-2.022-.18c-.513-.046-.734.664-.293.942l1.737 1.095c.208.13.291.4.197.633l-.789 1.953c-.2.495.377.934.767.582l1.534-1.388a.47.47 0 0 1 .637 0l1.533 1.388c.39.352.967-.087.767-.582l-.79-1.953a.52.52 0 0 1 .197-.633l1.738-1.095c.44-.278.22-.988-.293-.942l-2.022.18a.49.49 0 0 1-.515-.39z" />
        <path d="M2 2h12v2H4v11h16v-5h2v7h-9v3h4v2H7v-2h4v-3H2z" />
        <path d="M17 10v3h-2v-3zM7 13V8h2v5zm4 0V6h2v7z" />
      </g>
    </g>
  </Icon>
);
export { SvgFusionAnalyticWarehouse as FusionAnalyticWarehouse };
